<template>
  <div class="mt-2 mb-5">
    <div role="tablist">
      <b-card no-body class="mb-1" v-for="component in components" :key="component.id" style="border:none;">
        <b-card-header class="p-0" role="tab" style="border-bottom:none;">
            <b-button href="#" squared block variant="link" class="kub-btn-white text-decoration-none d-flex" v-b-toggle="component.toggle" :disabled="![shoppingCartComplete, addressComplete, paymentComplete][component.id-1]" @click="changeStep(component)">
              <b-iconstack font-scale="1" class="mr-2 align-self-end">
                <b-icon stacked icon="check2" scale="1" v-show="![shoppingCartComplete, addressComplete, paymentComplete][component.id-1]" style="color:#ddd;"></b-icon>
                <b-icon stacked icon="check2" scale="1" v-show="[shoppingCartComplete, addressComplete, paymentComplete][component.id-1]"></b-icon>
              </b-iconstack>
              <h3 class="font-weight-normal m-0 text-left when-open">{{component.title}}</h3>
              <b-icon icon="pencil" v-b-tooltip.hover title="Bearbeiten" scale="0.75" class="align-self-end ml-auto" v-if="[shoppingCartComplete, addressComplete, paymentComplete][component.id-1]"></b-icon>
            </b-button>
        </b-card-header>
        <b-collapse :id="component.toggle" :visible="component.visible" accordion="kub-summary-accordion" role="tabpanel">
            <b-card-body class="p-0 pt-3 pb-3">
              <b-card-text>
                <component :is="component.comp"></component>
              </b-card-text>
            </b-card-body>
        </b-collapse>
      </b-card>
      <div v-if="!orderLoaded && paymentComplete" class="text-center mt-5">
        <b-spinner label="Loading..." style="color:#002b36;"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import Data from '../../../data/main/summary/summary'

import Cart from './cart/Cart.vue'
import Address from './address/Address.vue'
import Payment from './payment/Payment.vue'

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      components: Data.components
    }
  },
  components: {
    appCart: Cart,
    appAddress: Address,
    appPayment: Payment
  },
  methods: {
    ...mapActions([
      'changeStatusShoppingCart',
      'changeStatusAddress',
      'changeStatusPayment'
    ]),
    changeStep (comp) {
      switch (comp.id) {
        case 1:
          this.changeStatusShoppingCart()
          if (this.addressComplete) {
            this.changeStatusAddress()
          }
          if (this.paymentComplete) {
            this.changeStatusPayment()
          }
          this.$root.$emit('bv::toggle::collapse', comp.toggle)
          break
        case 2:
          this.changeStatusAddress()
          if (this.paymentComplete) {
            this.changeStatusPayment()
          }
          this.$root.$emit('bv::toggle::collapse', comp.toggle)
          break
        case 3:
          this.changeStatusPayment()
          this.$root.$emit('bv::toggle::collapse', comp.toggle)
          break
      }
    }
  },
  computed: {
    ...mapGetters([
      'lg',
      'shoppingCartComplete',
      'addressComplete',
      'paymentComplete',
      'orderLoaded'
    ])
  }
}
</script>

<style scoped>
:not(.collapsed) > .when-open {
  color: #002b36 !important;
  font-weight: 500 !important;
}

</style>
